module.exports = __webpack_public_path__ + "media/icon_transaction/cat_3-0e65b9c4.png";